import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { UsuarioService } from "../../providers/usuario.service";
// import { CrearUsuarioComponent } from "./crear-usuario/crear-usuario.component";
// import { CrearUsuarioDialog } from "./crear-usuario/crear-usuario-dialog/crear-usuario-dialog.component";
// import { EditarUsuarioComponent } from "./editar-usuario/editar-usuario.component";
// import { EditarUsuarioDialog } from "./editar-usuario/editar-usuario-dialog/editar-usuario-dialog.component";
// import { EstadoUsuarioComponent } from "./estado-usuario/estado-usuario.component";
// import { EstadoUsuarioDialog } from "./estado-usuario/estado-usuario-dialog/estado-usuario-dialog.component";
// import { UsuarioComponent } from "./usuario/usuario.component";
// import { VerUsuariosComponent } from "./ver-usuarios/ver-usuarios.component";
import { TelefonoModule } from "../../components/telefono/telefono.module";
import { AutorizadorModule } from "../../components/autorizador/autorizador.module";
import { PropuestasService } from "../../providers/propuestas.service";
import { VerEstadosPropuestaComponent } from "./ver-estados-propuesta/ver-estados-propuesta.component";
import { CrearEstadoPropuestaComponent } from "./crear-estado-propuesta/crear-estado-propuesta.component";
import { EstadoPropuestaComponent } from "./estado-propuesta/estado-propuesta.component";
import { CrearEstadoPropuestaDialog } from "./crear-estado-propuesta/crear-estado-propuesta-dialog/crear-estado-propuesta-dialog.component";
import { EditarEstadoPropuestaComponent } from "./editar-estado-propuesta/editar-estado-propuesta.component";
import { EditarEstadoPropuestaDialog } from "./editar-estado-propuesta/editar-estado-propuesta-dialog/editar-estado-propuesta-dialog.component";
import { OrdenEstadoPropuestaDialog } from "./ordenar-estados-propuesta/ordenar-estado-propuesta-dialog.component";
import { EliminarEstadoPropuestaComponent } from "./eliminar-estado-propuesta/eliminar-estado-propuesta.component";
import { EliminarEstadoPropuestaDialog } from "./eliminar-estado-propuesta/eliminar-estado-propuesta-dialog/eliminar-estado-propuesta-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        TelefonoModule,
        AutorizadorModule,
    ],
    declarations: [
        CrearEstadoPropuestaComponent,
        CrearEstadoPropuestaDialog,
        OrdenEstadoPropuestaDialog,
        EditarEstadoPropuestaComponent,
        EditarEstadoPropuestaDialog,
        EliminarEstadoPropuestaComponent,
        EliminarEstadoPropuestaDialog,
        EstadoPropuestaComponent,
        VerEstadosPropuestaComponent
    ],
    providers: [
        PropuestasService
    ],
    entryComponents: [
        CrearEstadoPropuestaDialog,
        EditarEstadoPropuestaDialog,
        EditarEstadoPropuestaDialog,
        EliminarEstadoPropuestaDialog,
        OrdenEstadoPropuestaDialog,
    ],
    exports: [
        CrearEstadoPropuestaComponent,
        EditarEstadoPropuestaComponent,
        EliminarEstadoPropuestaComponent,
        EstadoPropuestaComponent,
        VerEstadosPropuestaComponent
    ]
})
export class EstadoPropuestaModule { }